// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    /*read more*/
    var readMoreTrigger = document.getElementsByClassName("-rm-trigger");
    
    var toggleMoreContent = function() {
        //var excerpt = this.parentNode.getElementsByClassName('-rm-excerpt')[0];
        var moreText = this.parentNode.getElementsByClassName('-rm-more');

        for (var i = 0; i < moreText.length; i++) {
          //console.log(this)
          if (moreText[i].classList.contains('-rm-on')) {
            //moreText[i].style.display = "none";
            moreText[i].classList.remove('-rm-on')
            this.classList.remove('-active')
            this.querySelector('span').innerHTML = "Ver mais erros";
          } else {
            //moreText[i].style.display = "flex";
            moreText[i].classList.add('-rm-on')
            this.classList.add('-active')
            this.querySelector('span').innerHTML = "Ver menos";
            
          }
        }
    };

    for (var i = 0; i < readMoreTrigger.length; i++) {
        readMoreTrigger[i].addEventListener('click', toggleMoreContent, false);
    } 


    gsap.registerPlugin(ScrollTrigger);

    const counter = document.querySelectorAll('.count');
    if (counter) {
      counter.forEach(el => {
          // 1. Get the raw string (e.g., "99,8")
          const rawEnd = el.dataset.end || "0";
          
          // 2. Clean it: replace comma with dot to make it a valid float for JS
          const cleanEnd = parseFloat(rawEnd.replace(',', '.')) || 0;
          
          // 3. Detect decimal places to keep the animation consistent
          // If "99,8", it detects 1 decimal place.
          const decimals = rawEnd.includes(',') ? rawEnd.split(',')[1].length : 0;

          const proxy = { val: 0 };

          gsap.to(proxy, {
            val: cleanEnd,
            duration: 2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 90%",
              toggleActions: "play none none reverse",
            },
            onUpdate: () => {
              // 4. Format the number back to pt-BR style
              let formattedNumber = proxy.val.toLocaleString('pt-BR', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
              });
              
              // 5. Add the % sign back if it's a percentage
              el.textContent = `${formattedNumber}`;
            }
          });
        });    
    }

    /*const typingEl = document.querySelectorAll(".-typing");
    if (typingEl.length > 0) {
      gsap.utils.toArray(".-typing").forEach((text) => {
        let content = text.textContent;
        text.textContent = ""; // clear first
        gsap.to(text, {
          duration: 2.5,
          text: content,  // Requires TextPlugin
          ease: "none"
        });
      });
    }*/
    // Fade-in sections on scroll
    gsap.utils.toArray(".-fade-in").forEach((secfade) => {
      gsap.from(secfade, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secfade,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".-animate-in").forEach((sec) => {
      /*gsap.to(sec, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "none",
        //ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });*/
      gsap.from(sec, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none "
        }
      });
    });

    //scrollspy
    /*document.addEventListener('DOMContentLoaded', function(){ 
      // grab the sections (targets) and menu_links (triggers)
      // for menu items to apply active link styles to
      const sections = document.querySelectorAll(".--spy");
      const menu_links = document.querySelectorAll(".--spy-nav-item a");
      

      // functions to add and remove the active class from links as appropriate
      const makeActive = (link) => menu_links[link].parentElement.classList.add("active");
      const removeActive = (link) => menu_links[link].parentElement.classList.remove("active");
      const removeAllActive = () => [...Array(sections.length).keys()].forEach((link) => removeActive(link));
      
      // change the active link a bit above the actual section
      // this way it will change as you're approaching the section rather
      // than waiting until the section has passed the top of the screen
      const sectionMargin = 100;
      
      // keep track of the currently active link
      // use this so as not to change the active link over and over
      // as the user scrolls but rather only change when it becomes
      // necessary because the user is in a new section of the page
      let currentActive = 0;

      // listen for scroll events
      window.addEventListener("scroll", () => {
        //console.log('k')

        const current = sections.length - [...sections].reverse().findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin ) - 1
        console.log(current)

        // only if the section has changed
        // remove active class from all menu links
        // and then apply it to the link for the current section
        if (current !== currentActive) {
          removeAllActive();
          currentActive = current;
          makeActive(current);

        }
      });
    }, false); */   
    
    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    //modal trigger
    var modalTrigger = document.getElementsByClassName("modal-trigger-btn");
    
    var toggleModal = function() {
        event.preventDefault();
        const modal = this.dataset.modal;
        if (modal) {
          document.getElementById(modal).classList.add('-modal-active');
        }
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("modal-active");
    };

    for (var i = 0; i < modalTrigger.length; i++) {
        modalTrigger[i].addEventListener('click', toggleModal, false);
    }

    //modal close
    var modalClose = document.getElementsByClassName("modal-close-btn");
    
    var closeModal = function() {
        event.preventDefault();
        const modals = document.querySelectorAll('.-modal');
        modals.forEach(element => {
          element.classList.remove('-modal-active');
        });
        const formModals = document.querySelectorAll('.-modal-form');
        formModals.forEach(element => {
          element.classList.remove('-active');
        });
        document.body.classList.remove("modal-active");
    };

    for (var i = 0; i < modalClose.length; i++) {
        modalClose[i].addEventListener('click', closeModal, false);
    }    
  
    
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;

      document.body.classList.remove("menu-active");
     
      scroll({
        //top: offsetTop-header,
        top: offsetTop,
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;
      if (document.querySelector("header").classList.contains('-sticky')) {
        
      }else{
        header = header-79;
      }
      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    } 


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });

    /*Tiny slider testimonials*/
    const tnsSliderGrid = document.querySelectorAll('.-grid-tns');
    tnsSliderGrid.forEach(SliderGrid => {
      const tnsSliderGrid = tns({
          rewind: true,
          container: SliderGrid,
          items: 3,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplayTimeout: 3000,
          gutter: 24,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:chevron-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:chevron-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                //autoplay: true,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                //autoplay: true,
                //nav: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          } 
      });
      // Reference the bar
      const progressBar = document.getElementById('progress-bar');

      // Function to update the bar
      function updateProgressBar(info) {
        // Total items (5) minus items shown (3) + 1 = The last possible "step" (3)
        const maxStep = info.slideCount - info.items + 1;

        // Calculate percentage based on the current step relative to the max step
        // We use Math.min to ensure it never exceeds 100%
        const percentage = Math.min((info.displayIndex / maxStep) * 100, 100);

        progressBar.style.width = percentage + "%";
      }

      // 1. Run once on initialization
      updateProgressBar(tnsSliderGrid.getInfo());

      // 2. Listen for every slide change
      tnsSliderGrid.events.on('indexChanged', function(info) {
        updateProgressBar(info);
      });
    });    

    /*Tiny slider gallery*/
    const tnsSliderGallery = document.querySelectorAll('.-gallery-tns');
    tnsSliderGallery.forEach(sliderGallery => {
      const tnsSliderGallery = tns({
          container: sliderGallery,
          mode: 'gallery',
          speed: 1500,
          /*animateIn: 'tns-fadeIn',
          animateOut: 'tns-fadeOut',*/
          items: 1,
          nav: true,
          controls: true,//here
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 0,
          loop: true,
          mouseDrag: false,
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:chevron-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:chevron-right"></iconify-icon></span>'],
          controlsPosition: "bottom",
          navPosition: "bottom",

          /*responsive: { 
              1366: {
                controls: true,
                nav: false,
              },
              768: {
                controls: false,
                nav: false,
              },
              320: {
                controls: false,
                nav: false,
              }, 
          }*/          
      });
    }); 

    /*Tiny slider testimonials*/
    const tnsSliderTestimonials = document.querySelectorAll('.-testimonials-tns');
    tnsSliderTestimonials.forEach(SliderTestimonials => {
      const tnsSliderTestimonials = tns({
          container: SliderTestimonials,
          items: 3,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplayTimeout: 4000,
          gutter: 16,
          loop: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                autoplay: true,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                autoplay: true,
                //nav: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          } 
      });
    });     



// Select all forms with the class 'ajax-form'
document.querySelectorAll('.ajax-form').forEach(form => {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    console.log('1')
    const currentForm = e.currentTarget;
    const btn = currentForm.querySelector('button[type="submit"]'); // Find button inside this form
    const actionName = currentForm.dataset.captchaAction || 'generic_form'; // Custom action name
    console.log('Action: '+actionName)
    btn.disabled = true;

    grecaptcha.ready(function () {
      grecaptcha.execute('6Lf0KZgsAAAAAAH5QshrGgkTTTnLn-GAmyrEuJZf', { action: actionName })
        .then(function (token) {
          // Find the hidden input inside THIS specific form
          currentForm.querySelector('.recaptcha_token').value = token;
          
          var data = new FormData(currentForm);
          return fetch(currentForm.action, { method: 'POST', body: data });
        })
        .then(function (res) {
          var ct = res.headers.get('content-type');
          var isJSON = ct && ct.indexOf('application/json') !== -1;

          if (isJSON) {
            return res.json().then(function (payload) {
              return { res: res, payload: payload };
            });
          } else {
            return res.text().then(function (html) {
              return { res: res, payload: { ok: res.ok, html: html } };
            });
          }
        })
        .then(function (pack) {
          var payload = pack.payload;
          console.log(pack)
          if (payload && payload.ok) {
            alert('Mensagem enviada com sucesso!');
            if (payload.redirect) {
              window.open(payload.redirect, '_blank');
            }
            currentForm.reset();
          } else {
            var msg = (payload && payload.error) ? payload.error : 
                      (payload && payload.errors ? payload.errors.join('\n') : 'Falha no envio.');
            alert(msg);
          }
          btn.disabled = false; // reabilita no sucesso
        })
        .catch(function () {
          alert('Erro ao enviar. Tente novamente.');
          btn.disabled = false; // reabilita no erro
        })
    });
  });
});

    // Submit contact reCAPTCHA v3 + fetch 
        

                 

     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('inovaisa_pocos_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('inovaisa_pocos_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('inovaisa_pocos_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('inovaisa_pocos_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    }); 


    /*dynamic header*/
    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      //console.log(window.innerWidth)
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        var vhMinWA = 200;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
                
        }else{
                header[0].classList.remove('-sticky');
                
        }

        if (scrollPosition > vhMinWA) {
                
                document.body.classList.add("-has-sticky");
        }else{
                
                document.body.classList.remove("-has-sticky");
        }
    };

}(window.jQuery, window, document));